import React from 'react';
import styles from './Share.module.scss';
import { ReactComponent as Twitter } from '../../../assets/social-twitter.svg';
import { ReactComponent as Facebook } from '../../../assets/social-facebook.svg';
import { ReactComponent as Email } from '../../../assets/social-email.svg';
import { ReactComponent as Whatsapp } from '../../../assets/social-whatsapp.svg';

function Share({ emailBody, text, hashtags }) {
    const emailBodyEncoded = encodeURIComponent(emailBody);
    const urlEncoded = encodeURIComponent(window.location.href);
    const textEncoded = encodeURIComponent(text);
    const hashtagsEncoded = encodeURIComponent(hashtags);

    return (
        <div className={styles.container}>
            <h3 className={styles.label}>Share via</h3>
            <ul className={styles.list}>
                <li className={styles.item}>
                    <a title="Facebook" className={styles.link} href={`https://www.facebook.com/sharer.php?u=${urlEncoded}`} target="_blank" rel="noopener noreferrer">
                        <Facebook className={styles.icon}/>
                    </a>
                </li>
                <li className={styles.item}>
                    <a title="Twitter" className={styles.link} href={`https://twitter.com/share?url=${urlEncoded}&text=${textEncoded}&hashtags=${hashtagsEncoded}`} target="_blank" rel="noopener noreferrer">
                        <Twitter className={styles.icon}/>
                    </a>
                </li>
                <li className={styles.item}>
                    <a title="WhatsApp"className={styles.link} href={`https://api.whatsapp.com/send?text=${textEncoded}%20${urlEncoded}`} target="_blank" rel="noopener noreferrer">
                        <Whatsapp className={styles.icon}/>
                    </a>
                </li>
                <li className={styles.item}>
                    <a title="Email" className={styles.link} href={`mailto:?subject=${textEncoded}&body=${emailBodyEncoded}%20${urlEncoded}`} target="_blank" rel="noopener noreferrer">
                        <Email className={styles.icon}/>
                    </a>
                </li>
            </ul>
        </div>
    );
}

export default Share;